import { render, staticRenderFns } from "./InstallPWADesktopView.vue?vue&type=template&id=7c13fa76&scoped=true"
import script from "./InstallPWADesktopView.vue?vue&type=script&lang=ts"
export * from "./InstallPWADesktopView.vue?vue&type=script&lang=ts"
import style0 from "./InstallPWADesktopView.vue?vue&type=style&index=0&id=7c13fa76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c13fa76",
  null
  
)

export default component.exports